module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx-wdzf"
  }, [_c('div', {
    staticStyle: {
      "overflow-y": "auto"
    },
    style: ({
      height: (_vm.pullHeight - 117) + 'px'
    })
  }, [_c('group', {
    attrs: {
      "gutter": "0.77em"
    }
  }, [_c('x-input', {
    attrs: {
      "show-clear": false
    },
    model: {
      value: (_vm.fpDetail.name),
      callback: function($$v) {
        _vm.$set(_vm.fpDetail, "name", $$v)
      },
      expression: "fpDetail.name"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "0.7em",
      "width": "5em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('sup', {
    staticStyle: {
      "color": "#F00",
      "margin-left": "-10px",
      "float": "left",
      "width": "3px"
    }
  }, [_vm._v("*")]), _vm._v("名 称")])]), _vm._v(" "), (_vm.fpDetail.type === 1) ? _c('x-input', {
    attrs: {
      "show-clear": false
    },
    model: {
      value: (_vm.fpDetail.taxpayerNo),
      callback: function($$v) {
        _vm.$set(_vm.fpDetail, "taxpayerNo", $$v)
      },
      expression: "fpDetail.taxpayerNo"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "0.8em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('sup', {
    staticStyle: {
      "margin-left": "-10px",
      "float": "left",
      "width": "3px",
      "color": "#F00"
    }
  }, [_vm._v("*")]), _vm._v("税 号")])]) : _vm._e(), _vm._v(" "), _c('x-input', {
    attrs: {
      "show-clear": false
    },
    model: {
      value: (_vm.fpDetail.mobile),
      callback: function($$v) {
        _vm.$set(_vm.fpDetail, "mobile", $$v)
      },
      expression: "fpDetail.mobile"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    staticStyle: {
      "letter-spacing": "0.5em"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("手机号")])]), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "电子邮箱",
      "show-clear": false
    },
    model: {
      value: (_vm.fpDetail.email),
      callback: function($$v) {
        _vm.$set(_vm.fpDetail, "email", $$v)
      },
      expression: "fpDetail.email"
    }
  }), _vm._v(" "), (_vm.fpDetail.type === 1) ? _c('x-input', {
    attrs: {
      "title": "单位地址",
      "show-clear": false
    },
    model: {
      value: (_vm.fpDetail.address),
      callback: function($$v) {
        _vm.$set(_vm.fpDetail, "address", $$v)
      },
      expression: "fpDetail.address"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fpDetail.type === 1) ? _c('x-input', {
    attrs: {
      "title": "电话号码",
      "show-clear": false
    },
    model: {
      value: (_vm.fpDetail.telephone),
      callback: function($$v) {
        _vm.$set(_vm.fpDetail, "telephone", $$v)
      },
      expression: "fpDetail.telephone"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fpDetail.type === 1) ? _c('x-input', {
    attrs: {
      "title": "开户银行",
      "show-clear": false
    },
    model: {
      value: (_vm.fpDetail.depositBank),
      callback: function($$v) {
        _vm.$set(_vm.fpDetail, "depositBank", $$v)
      },
      expression: "fpDetail.depositBank"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fpDetail.type === 1) ? _c('x-input', {
    attrs: {
      "title": "银行账号",
      "show-clear": false
    },
    model: {
      value: (_vm.fpDetail.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.fpDetail, "bankAccount", $$v)
      },
      expression: "fpDetail.bankAccount"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-switch', {
    attrs: {
      "title": "默认抬头"
    },
    model: {
      value: (_vm.isDefault),
      callback: function($$v) {
        _vm.isDefault = $$v
      },
      expression: "isDefault"
    }
  })], 1), _vm._v(" "), _c('P', {
    staticStyle: {
      "margin-top": "10px",
      "color": "#888",
      "font-size": "14px",
      "padding-left": "15px"
    }
  }, [_vm._v("建议全部填写，以便开具增值税专用发票")])], 1), _vm._v(" "), _c('div', {
    staticClass: "queding",
    staticStyle: {
      "position": "static"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('/viewCard')
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticClass: "queding delete",
    staticStyle: {
      "position": "static"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteFp.apply(null, arguments)
      }
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": "3000"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }, [_vm._v(_vm._s(_vm.toastMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": _vm.loadingText
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  }), _vm._v(" "), _c('confirm', {
    staticClass: "zzz",
    on: {
      "on-confirm": _vm.onConfirm
    },
    model: {
      value: (_vm.confirmStatus),
      callback: function($$v) {
        _vm.confirmStatus = $$v
      },
      expression: "confirmStatus"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px",
      "color": "#333",
      "font-size": "16px",
      "font-weight": "bold",
      "height": "1.3em"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "margin-right": "10px",
      "vertical-align": "middle",
      "margin-top": "-1px"
    },
    attrs: {
      "src": require("../../assets/img/tit.png")
    }
  }), _vm._v("确认要删除该名片吗？")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2d94118"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/addFinish1.vue
// module id = 358
// module chunks = 0